import React from 'react';
import CloseButton from '../controls/closeButton/closeButton';
import HelpButton from './helpButton.js';
export default (function (props) {
  return /*#__PURE__*/React.createElement("header", {
    className: props.getClassName('panel-header-centered-text'),
    "data-aid": props.automationId,
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: 'title ' + props.titleType.toLowerCase()
  }, props.translateIfNeeded(props.title)), props.subtitle ? /*#__PURE__*/React.createElement("div", {
    className: "subtitle",
    key: "subtitle"
  }, props.translateIfNeeded(props.subtitle)) : null, props.onHelp ? /*#__PURE__*/React.createElement(HelpButton, {
    onClick: props.onHelp,
    key: "help"
  }) : null, props.onClose ? /*#__PURE__*/React.createElement(CloseButton, {
    onClick: props.onClose,
    key: "close"
  }) : null);
});